import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://www.nidoportal.com';
const DEFAULT_DESCRIPTION = 'NIDO, portal inmobiliario de Cuyo. Encontrá casas, departamentos, alquileres y desarrollos en Mendoza, San Juan y San Luis.';

const publicPages = [
  { test: /^\/$/, title: 'NIDO · Portal Inmobiliario de Cuyo', description: DEFAULT_DESCRIPTION },
  { test: /^\/properties/, title: 'Propiedades en Cuyo | NIDO', description: 'Casas, departamentos, terrenos y locales en venta y alquiler en Mendoza, San Juan y San Luis.' },
  { test: /^\/buscar$/, title: 'Buscar propiedades en Cuyo | NIDO', description: 'Buscá casas, departamentos, terrenos y locales en venta o alquiler en Mendoza, San Juan y San Luis con filtros y mapa.' },
  { test: /^\/explorar-cuyo/, title: 'Explorá propiedades en Cuyo | NIDO', description: 'Recorré Mendoza, San Juan y San Luis por provincia, departamento y localidad.' },
  { test: /^\/zonas\/mendoza\/quinta-seccion/, title: 'Quinta Sección, Mendoza | Guía de zona NIDO', description: 'Historia, lugares y propiedades destacadas de Quinta Sección, Mendoza.' },
  { test: /^\/vacaciones/, title: 'Alquileres temporarios en Cuyo | NIDO', description: 'Cabañas, casas y alojamientos para disfrutar Mendoza, San Juan y San Luis.' },
  { test: /^\/desarrollos/, title: 'Desarrollos inmobiliarios en Cuyo | NIDO', description: 'Conocé barrios privados, edificios, loteos y proyectos en preventa de la región de Cuyo.' },
  { test: /^\/vivir-cuyo/, title: 'Vivir Cuyo · Guías y lugares | NIDO', description: 'Historias, destinos y claves para elegir dónde vivir e invertir en Cuyo.' },
  { test: /^\/register/, title: 'Crear una cuenta | NIDO Portal Inmobiliario', description: 'Creá tu perfil particular, profesional o de desarrolladora en NIDO.' },
  { test: /^\/login/, title: 'Ingresar | NIDO Portal Inmobiliario', description: 'Ingresá a tu panel para gestionar propiedades, mensajes y favoritos.' },
];

const nonIndexPath = /^\/(client|mensajes|mis-publicaciones|favoritos|alertas|publicar|mi-perfil|admin|desarrollador|welcome|verify|auth\/callback|forgot-password|reset-password|pago|testimagen|login|register)(\/|$)/;
const facetedPath = /^\/(venta|alquiler|alquiler_temporal|alquiler_vacacional)\//;

function setMeta(selector, attribute, value) {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
}

export default function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = publicPages.find((item) => item.test.test(pathname));
    const title = page?.title || 'NIDO · Portal Inmobiliario de Cuyo';
    const description = page?.description || DEFAULT_DESCRIPTION;
    const canonical = `${BASE_URL}${pathname === '/' ? '/' : pathname.replace(/\/$/, '')}`;
    document.title = title;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[name="robots"]', 'content', nonIndexPath.test(pathname) || facetedPath.test(pathname) ? 'noindex,follow' : 'index,follow,max-image-preview:large');
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', canonical);
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    const canonicalLink = document.head.querySelector('link[rel="canonical"]');
    if (canonicalLink) canonicalLink.setAttribute('href', canonical);
  }, [pathname]);

  return null;
}
